import { Component } from 'preact'
import PanelHeader from './PanelHeader'
import PanelBody from './PanelBody'

class Panel extends Component {
  constructor (props) {
    super()
    this.state = {
      isOpen: true
    }
  }

  togglePanel () {
    this.setState({ isOpen: !this.state.isOpen })
  }

  render ({ children, class: customClass, collapsible, title }, { isOpen }) {
    return (
      <div class={customClass}>
        <div class='panel'>
          { title
            ? <PanelHeader
              collapsible={collapsible}
              isOpen={isOpen}
              togglePanel={() => this.togglePanel()}
              title={title}
            />
            : null }
          <PanelBody
            collapsible={collapsible}
            isOpen={isOpen}
          >
            {children}
          </PanelBody>
        </div>
      </div>
    )
  }
}

export default Panel
